import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { AgreementsScreen } from "../../screens/settings/index.ts";

/** `/settings/agreements`: the data processing agreement. Only administrators open it. */
export const Route = createFileRoute("/_app/settings/agreements")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("agreements.getDpa", {})),
  component: AgreementsScreen,
});
